// src/services/investorService.js
import api from './api';

const getHoldings = (params = {}) => {
  return api.get('/investor/holdings', { params });
};

const getHoldingForToken = (tokenId) => {
  return api.get(`/investor/holdings/${tokenId}`);
};

const getTokenEventLog = (tokenId) => {
  return api.get(`/investor/holdings/${tokenId}/events`);
};

const pushTokenToBid = (tokenId) => {
  return api.post(`/investor/tokens/${tokenId}/push-to-bid`);
};

const investorService = {
  getHoldings,
  getHoldingForToken,
  getTokenEventLog,
  pushTokenToBid,
};

export default investorService;
